import { initializeApollo } from '@zoopla/apollo';
import { ArticleCollection } from '@zoopla/cms/article-collection';
import { withSSROptimizely } from '@zoopla/optimizely';
import NewHomesPage from './pages/NewHomesPage';
import { getNewHomesArticleCollection } from './utils/getNewHomesArticleCollection';
import { GetServerSidePropsContext } from 'next';

type NewHomesProps = {
    articleCollection?: ArticleCollection;
};

const NewHomes = ({ articleCollection }: NewHomesProps) => {
    return <NewHomesPage articleCollection={articleCollection} />;
};

async function _getServerSideProps({ req }: GetServerSidePropsContext) {
    const apolloClient = initializeApollo(null, req.headers);

    const articleCollection = await getNewHomesArticleCollection(apolloClient);

    if (!articleCollection) {
        return {
            props: {
                articleCollection: null
            }
        };
    }

    return {
        props: {
            articleCollection: articleCollection
        }
    };
}

export const getServerSideProps =
    withSSROptimizely.getServerSideProps(_getServerSideProps);

export default NewHomes;
